import React from 'react';

export default function () {
    return (
        <div className="loading-indicator">
            <img src="/loader.gif"/>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/loadingIndicator.jsx